import { render, staticRenderFns } from "./PrivacyTerms.vue?vue&type=template&id=23f34f0a&"
import script from "./PrivacyTerms.vue?vue&type=script&lang=js&"
export * from "./PrivacyTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports